import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckSmsMutationRequest, CheckSmsMutationResponse, CheckSmsHeaderParams, CheckSms403, CheckSms500 } from "../types/CheckSms";

/**
 * @summary Проверка введенного кода из смс
 * @link /api/auth/check/sms
 */

export function useCheckSms <TData = CheckSmsMutationResponse, TError = CheckSms403 | CheckSms500, TVariables = CheckSmsMutationRequest>(headers?: CheckSmsHeaderParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/auth/check/sms`,
        data,
        
        headers: { ...headers, ...clientOptions.headers },
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
